import React from 'react';
import { Box, SvgIconProps } from '@material-ui/core';
import BrandSVG from '€components/svgs/loan-logo.svg';

const Loading = () => {
    const svgIconProps: SvgIconProps = {
        fontSize: 'inherit',
    };

    return (
        <Box
            color="secondary.contrastText"
            bgcolor="background.default"
            textAlign="center"
            justifyContent="center"
            alignItems="center"
            display="flex"
            height="100vh"
            flexDirection="column"
            fontSize="7.5rem"
        >
            <BrandSVG />
        </Box>
    );
};

export default Loading;
